import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { api, errorMessage } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function AdminLogin() {
  useSeo({ title: "Espace administrateur", description: "Accès réservé.", noindex: true });
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-ivory px-5">
      <form onSubmit={submit} className="w-full max-w-sm space-y-7" data-testid="admin-login-form">
        <Logo variant="stacked" />
        <h1 className="display text-[2.4rem]">Espace administrateur</h1>
        <div><label htmlFor="ad-email" className="flabel">E-mail</label><input id="ad-email" type="email" autoComplete="username" className="field" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" /></div>
        <div><label htmlFor="ad-pass" className="flabel">Mot de passe</label><input id="ad-pass" type="password" autoComplete="current-password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" /></div>
        {error && <p role="alert" className="text-[14px] text-red-800" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="w-full rounded-full bg-ink py-4 text-sm font-semibold text-ivory disabled:opacity-70" data-testid="admin-login-submit">{loading ? "Connexion…" : "Se connecter"}</button>
      </form>
    </main>
  );
}
